.root {
    position: relative;
    width: 29px;
    height: 29px;
    flex-shrink: 0;
    border-radius: 50%;
    background-color: var(--black);
    display: flex;
    align-items: center;
    justify-content: center;
}

.ring {
    position: absolute;
    inset: 2px;
    border-radius: 50%;
    border: 1.5px solid var(--white);
}

.text {
    position: relative;
    color: var(--white);
    font-family: FormaDJRMicro, sans-serif;
    font-weight: 500;
    font-size: 9px;
    line-height: 1.5;
    text-align: center;
}
